(function() {
  var SUPPORTED_REGIONS = ['us', 'uk', 'jpn', 'nz', 'eu', 'ind'];

  // Editable mapping: set a host per region if it doesn't follow <region>.<apex-domain>
  // Leave a value empty ('') to use data-attribute overrides or the default fallback.
  var REGION_HOSTS = {
    us: 'us.jsindustries.com',   // e.g. 'shop.us-example.com'
    uk: 'uk.jsindustries.com',   // e.g. 'example.co.uk'
    jpn: 'jsindustries.jp',  // e.g. 'example.co.jp'
    nz: 'jsindustries.co.uk',   // e.g. 'nz.example.com'
    eu: 'jsindustries.com',   // e.g. 'example.eu'
    ind: 'id.jsindustries.com'   // e.g. 'example.in'
  };

  function sanitizeHost(raw) {
    if (!raw) return '';
    var trimmed = String(raw).trim();
    try {
      if (trimmed.indexOf('://') !== -1) {
        return new URL(trimmed).host;
      }
    } catch (e) {}
    return trimmed;
  }

  function getApexHost(currentHost) {
    var host = String(currentHost || window.location.hostname).replace(/^www\./, '');
    var regionPrefix = host.split('.')[0];
    if (SUPPORTED_REGIONS.indexOf(regionPrefix) !== -1) {
      return host.substring(regionPrefix.length + 1);
    }
    return host;
  }

  function getCurrentRegion(currentHost) {
    var host = String(currentHost || window.location.hostname).replace(/^www\./, '');
    var regionPrefix = host.split('.')[0];
    return SUPPORTED_REGIONS.indexOf(regionPrefix) !== -1 ? regionPrefix : null;
  }

  function getRegionHostFromDataAttributes(container, region) {
    if (!container) return '';
    var attr = 'data-' + region + '-host';
    var raw = container.getAttribute(attr) || '';
    return sanitizeHost(raw);
  }

  function buildRegionHost(container, region, apexHost) {
    var mapped = sanitizeHost(REGION_HOSTS[region] || '');
    if (mapped) return mapped;
    var override = getRegionHostFromDataAttributes(container, region);
    if (override) return override;
    return region + '.' + apexHost;
  }

  function getSessionRegion() {
    try {
      if(urlParams.has('countryCode')){
        var value = urlParams.get('countryCode');
      }else{
        var value = sessionStorage.getItem('geo_sl');
      }
      if (!value) return null;
      var region = String(value).toLowerCase();
      return SUPPORTED_REGIONS.indexOf(region) !== -1 ? region : null;
    } catch (e) {
      return null;
    }
  }

  function computeTargetHost(container) {
    var apex = getApexHost();
    var sessionRegion = getSessionRegion();
    var currentRegion = getCurrentRegion();

    console.log('[ShopTheLook] sessionRegion:', sessionRegion, 'currentRegion:', currentRegion, 'apex:', apex);

    if (!sessionRegion) return '';
    if (sessionRegion === currentRegion) return '';

    // Prefer explicit mapping, then data-attribute override, then default
    return buildRegionHost(container, sessionRegion, apex);
  }

  function bindShopTheLook(container) {
    if (!container || container.getAttribute('data-stl-bound') === '1') return;
    container.setAttribute('data-stl-bound', '1');

    var targetHost = computeTargetHost(container);
    if (!targetHost) {
      console.log('[ShopTheLook] no targetHost (no session or same region); links will remain unchanged');
    } else {
      console.log('[ShopTheLook] targetHost resolved:', targetHost);
    }

    container.addEventListener('click', function(event) {
      var target = event.target;
      var anchor = target && target.closest ? target.closest('a') : null;
      if (!anchor || !container.contains(anchor)) return;

      var href = anchor.getAttribute('href');
      console.log('[ShopTheLook] click on anchor. href:', href);

      if (!href || href.charAt(0) === '#') {
        console.log('[ShopTheLook] skip: empty or hash link');
        return;
      }

      try {
        var url = new URL(href, window.location.origin);
        console.log('[ShopTheLook] parsed URL:', url.toString());

        if (!url.pathname || url.pathname.indexOf('/products/') === -1) {
          console.log('[ShopTheLook] skip: not a product link');
          return;
        }

        // If we have not resolved a target host (no geo or same region), do nothing
        if (!targetHost) {
          console.log('[ShopTheLook] no targetHost set; leaving link unchanged');
          return;
        }

        if (targetHost === window.location.host) {
          console.log('[ShopTheLook] targetHost equals current host; leaving link unchanged');
          return;
        }

        var newUrl = new URL(url.href);
        newUrl.host = targetHost;
        console.log('[ShopTheLook] rewriting to:', newUrl.toString());

        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0 || anchor.target === '_blank') {
          console.log('[ShopTheLook] modified anchor href for new-tab/middle-click');
          anchor.href = newUrl.toString();
          return;
        }

        event.preventDefault();
        console.log('[ShopTheLook] navigating to', newUrl.toString());
        window.location.href = newUrl.toString();
      } catch (e) {
        console.log('[ShopTheLook] error while processing link', e);
      }
    }, true);
  }

  function initShopTheLook(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll ? scope.querySelectorAll('.box__shop-the-look') : [];
    if (!containers.length) {
      console.log('[ShopTheLook] no containers found in scope');
    }
    containers.forEach(bindShopTheLook);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initShopTheLook(document); });
  } else {
    initShopTheLook(document);
  }

  document.addEventListener('shopify:section:load', function(e) {
    initShopTheLook(e.target || document);
  });
})(); 